/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/calendar_list',['require','./page','text!../../../views/calendar_list.html'],function(require) {

	var Page = require('./page');
	var template = require('text!../../../views/calendar_list.html');

	return Backbone.View.extend({

		template : _.template(template),

		initialize : function(options) {
			this.monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
			this.monthNamesShort = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

			// Set dates
			var dateData = options.date.split("-");
			this.date = new Date(dateData[0], dateData[1]-1, 1, 0, 0, 0);
			this.month = this.date.getMonth();
			this.year = this.date.getFullYear();
			
			// Get calendar contents
			this.getContents();		
			
			// Render the html
			this.render();
		},

		render : function() {
			var data = {
				"SHOWPREV" : this.showPrev,
				"DATEPREV" : this.datePrev,
				"SHOWNEXT" : 1,
				"MONTHNAV": this.monthNav,
				"CONTENTS": this.contents
			};
			this.$el.html(this.template(data));
			return this.$el;
		},

		getContents : function() {
			var date = ("0" + (this.date.getMonth() + 1)).slice(-2)+"/01/"+this.year;			
			var d;
			$.ajax({
		        url: '/library/ajax/get_calendar.cfm',
		        data: {month: date},
		        async: false,   // this is the important line that makes the request sincronous
		        type: 'GET',
		        dataType: 'json',
		        success: function(output) {
	                d = output;
		        }
			});		
			
			this.parseData(d);
		},
		
		parseData: function(data) {
			var result = new Array();
			_.each(data.CALENDAR_LIST, function(item) {
				var itemInfo = new Array();
				itemInfo["TITLE"] = item.TITLE;
				itemInfo["BLURB1"] = item.BLURB1;
				itemInfo['MYPATH'] = item.MYPATH;
				
				// Type 1=single day, 2=consecutive, 3=repeated
				var date;
				var itemDate = new Date(item.DATE);
				switch(item.DATETYPE) {
					case 1:
						// Single day
						date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2);;
						break;
					case 2:
						// Connect beginning and end date
						var endDate = new Date(item.END_DATE);
						
						date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2);;
						date += " through ";
						date += ("0" + (endDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + endDate.getDate()).slice(-2)+".&nbsp;"+endDate.getFullYear().toString().substr(2,2);;						
						break;
					case 3:
						// This is a recurring event, just show the date
						date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2);; 
						break;
					default:
						break;
				}
				itemInfo["DATE"] = date;
				itemInfo["IMAGE"] = item.IMAGE1;
				result.push(itemInfo);
				
			});
			this.monthsList = data.MONTH_LIST;
			this.contents = result;
		},

		createMonthNav : function() {
			// This Month
			var today = new Date();
			var thisMonth = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);
			
			// Extract months
			var months = new Array();
			for(var i=0;i<this.monthsList.length;i++) {
				var CDDATE = this.monthsList[i].CDDATE.split('/');
				var CDMONTH = CDDATE[1].replace(/^0+/, '');
				
				// Only use if date >= today
				if(new Date(CDDATE[0], CDDATE[1]-1, 1, 0, 0, 0).getTime()>=thisMonth.getTime()) {
					months.push(this.monthsList[i].CDDATE);
				}
			}	
			
			// Create holder container
			this.monthNav = new Array();
			for(var i=0;i<months.length;i++) {
				var CCDATE = months[i].split('/');
				var iMonth = parseInt(CCDATE[1]);
				var iYear = parseInt(CCDATE[0]);
				var data = {FULLDATE: iYear+"-"+(iMonth)+"-1", MONTH: this.monthNamesShort[iMonth-1], YEAR: this.year};
				
				this.monthNav.push(data);
			}
		},
		
		// Returns MM/DD/YYYY 
		firstDayInPreviousMonth : function(yourDate) {
		    var d = new Date(yourDate);
		    d.setDate(1);
		    d.setHours(0);		    
		    d.setMinutes(0);
		    d.setSeconds(0);
		    d.setMilliseconds(0);
		    d.setMonth(d.getMonth());
		    
		    var dateStr;
		    dateStr = d.getFullYear()+"-"+d.getMonth()+"-1";
		    return dateStr;
		},
		
		formatDate: function() {
			return "NEW DATE";
		}
	});
});

